import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../../axios/api';
import * as actions from "../../../store/actions";
import axios from "axios";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Typography, IconButton, TextField, FormControl,
} from '@mui/material';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../../../containers/Admin/Forms/styles';
import CloseIcon from '@mui/icons-material/Close';
import Upload from '../../../UI/Upload';
import FileList from '../../../UI/FileList';
import confirm from '../../../UI/Confirm/confirm';

const ModalAttachmentFilesEquipmentModel = (props) => {
  const attachmentOnModal = props.modalContent;
  let handleType;
  const dispatch = useDispatch();

  const [isNewData, setIsNewData] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [uploadSubmitError, setUploadSubmitError] = useState(false)
  const [uploadEmptyFileError, setUploadEmptyFileError] = useState(false)
  const [description, setDescription] = useState('');
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const equipmentModel = useSelector(state => state.equipmentModels.equipmentModel);

  const handleManageAttachments = (index, body, handleType) => dispatch(actions.handleManageAttachments(index, body, handleType))
  const equipmentModelId = useSelector((state) => state.equipmentModels.equipmentModel._id)
  const allAttachmentsOfEquipmentModel = equipmentModel.attachments.map(attachment => ({ _id: attachment._id, description: attachment.description, files: attachment.files.map(file => file._id) })) || [];

  const fetchEquipmentModel = useCallback(() => dispatch(actions.fetchEquipmentModelById(equipmentModelId)));

  const recovery = () => {
    setDescription(props.type === 'edit' ? attachmentOnModal.description : '')
    setUploadedFiles(props.type === 'edit' ? attachmentOnModal.files : [])
  }
  useEffect(() => {
    setIsNewData(props.type !== 'edit')
    recovery();
  }, [])

  const handleSubmit = async e => {
    e.preventDefault();
    let hasError = false;

    const notUploaded = uploadedFiles.filter(fl => fl.isNotUploaded)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = [];

    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    });

    if (uploadedFiles.length === 0) {
      setUploadEmptyFileError(true);
      hasError = true;
    }

    if (hasError) return;

    const body = {
      attachments: [
        // all previous files, except file inside the modal
        ...allAttachmentsOfEquipmentModel.filter(attachment => attachment._id !== attachmentOnModal._id),
        {
          _id: attachmentOnModal._id,
          description,
          files: filesIds
        }
      ]
    };
    
    handleManageAttachments(equipmentModel._id, body, props.type)
      .then(result => {        
        if (result === 'success') {
          fetchEquipmentModel()
          props.closeModal(false, 'close')
        }
      })
  }

  const handleUpload = files => {
    const uploadingFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      progress: 0,
      isNotUploaded: true,
      error: false,
      url: null
    }));
    setUploadedFiles(prevUf => prevUf.concat(uploadingFiles))
    uploadingFiles.forEach(processUpload);
  };

  const updateFile = (id, data) => {
    setUploadedFiles(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };

  const processUpload = async uploadedFile => {
    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("files/signurl", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType,
          source: 'web',
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              error: false,
              loading: false,
            });
          })
          .catch(() => {
            updateFile(uploadedFile.id, {
              error: true,
              loading: false,
            });
          });
      })
    })
  }

  const handleDeleteFileInsideAnAttachment = (id) => setUploadedFiles(prev => prev.filter(file => file.id !== id))

  const handleDeleteAttachment = (attachmentId) => {
    confirm(i18n.t('handleDeleteDocumentModalSupport.confirm'),
      {
        title: i18n.t('handleDeleteDocumentModalSupport.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          const body = {
            attachments: allAttachmentsOfEquipmentModel.filter(attachment => attachment._id !== attachmentId)
          };

          handleManageAttachments(equipmentModel._id, body, handleType='delete').then(async (result) => {
            if (result === 'success') {
              fetchEquipmentModel()
              props.closeModal(false, 'close')

              const promise = attachmentOnModal.files.map(file => API.delete(`files/${file._id}`))
              await Promise.all(promise)
            }
          })
        },
      )
  }


  const styles = {
    opacityContainer: {
      position: 'relative'
    },
    fileError: {
      color: '#f44336'
    },
		submittedContainer: {
			display: 'flex',
			color: 'grey',
			fontSize: '0.8rem',
			marginTop: '1rem'
		}
  }

  return (
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
      <DivFormTitle>
        <Typography variant='h6'>{
          props.type === 'edit' ? 
          i18n.t('attachmentFilesEquipmentModelsModal.editTitle')
          : i18n.t('attachmentFilesEquipmentModelsModal.createTitle')
          }
        </Typography>
        {!isNewData &&
          <DivSubmitButtons>
            {editMode ?
              <>
                <IconButton onClick={() => { setEditMode(false); recovery(); }} size="large"><CloseIcon color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
              </> :
              <>
                <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                <IconButton
                  onClick={() => handleDeleteAttachment(props.modalContent._id)}
                  size="large"><DeleteIcon /></IconButton>
              </>
            }
          </DivSubmitButtons>
        }
      </DivFormTitle>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          label={i18n.t('modalSupportTextField.label')}
          multiline
          minRows={3}
          disabled={!isNewData && !editMode}
          name='description'
          onChange={event => setDescription(event.target.value) }
          value={description} />
      </FormControl>
      <Upload onUpload={handleUpload} disabled={!isNewData && !editMode} />
      {!isEmpty(uploadedFiles) && (
        <FileList files={uploadedFiles} onDelete={handleDeleteFileInsideAnAttachment} disabled={!editMode && !isNewData} />
      )}
      {uploadSubmitError && <div style={styles.fileError}>{i18n.t('uploadSubmitErrorModalSupport.label')}</div>}
      {uploadEmptyFileError && <div style={styles.fileError}>{i18n.t('uploadEmptyFileErrorModalSupport.label')}</div>}
      {isNewData &&
        <DivSubmitButtons>
          <IconButton onClick={() => props.closeModal(false, 'close')} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
          <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
        </DivSubmitButtons>
      }

    </FormStyled>
  );
}

export default ModalAttachmentFilesEquipmentModel;
